var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.505,
    height: 15.341,
    viewBox: "0 0 11.505 15.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.238,7.67a3.62,3.62,0,0,0,3.356-3.835,3.386,3.386,0,1,0-6.712,0A3.62,3.62,0,0,0,163.238,7.67Z",
    transform: "translate(-157.485 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.564,322.645a2.876,2.876,0,0,0-2.876-2.876h-2.2l.215.2a.255.255,0,0,1,0,.38l-.459.427a.414.414,0,0,0-.107.426l.886,2.142a.538.538,0,0,1-.051.455l-1.011,1.489a.167.167,0,0,1-.3,0L75.652,323.8a.538.538,0,0,1-.051-.455l.886-2.142a.414.414,0,0,0-.107-.426l-.459-.427a.255.255,0,0,1,0-.38l.215-.2h-2.2a2.876,2.876,0,0,0-2.876,2.876v2.876a.958.958,0,0,0,.959.959h9.588a.958.958,0,0,0,.959-.959v-2.876Z",
    transform: "translate(-71.059 -311.14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.a852ac34230665f7c2758b0d7b068e77.svg";
export { ForwardRef as ReactComponent };